'use strict';

function LoanOffers() {
  var _this = this;

  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  this._moneyModelPath = 'money.loans';

  // View path is the path to the pug view not URL
  this.offerViews = {
    no_offer: {
      viewPath: '/member/loans/dashboard/tabs/offers/no-offer'
    },
    mogo_no_offer: {
      viewPath: '/member/loans/dashboard/tabs/offers/mogo-no-offer',
      viewId: 'LoanOffersMogoNoOffer'
    },
    offer: {
      viewPath: '/member/loans/dashboard/tabs/offers/level-up',
      viewId: 'LoanOffersLevelUp'
    },
    status: {
      viewPath: '/member/loans/application/status-body',
      viewId: 'LoanApplicationStatus'
    }
  };

  this.init = function () {
    _this._super();
    _this._portalPresenter = document.getElementById('Portal').mogo();
  };

  this.initAllReady = function () {
    _this._super();
  };

  this.initPage = function () {
    // Redirect users that has no loans.
    if (_this._getLoanStatus() === null) return _this.history.goToUrl(_this.paths.loans.router);

    _this._$node = $(_this.node);
    _this._offerStatus = _this._getOfferStatus();
    _this._loanObj = _this._getLoanStatus();
    _this._loanStatus = _this._loanObj ? _this._loanObj.status : '';
    _this._lenderId = _this.getLoanLenderId();

    // User with application in progress.
    if (_this._getApplicationStatus() !== null) {
      // user with active loan and level up offer, applies to Mogo Members only.
      _this._setupViewSection('status', _this.offerViews);
    } else if (_this._offerStatus === 'active') {
      // Active offer data
      _this._setupViewSection('offer', _this.offerViews);
    } else if (_this._offerStatus === null) {
      if (_this._loanStatus !== 'active') {
        // IE display no offer view for Paid_off members
        _this._setupViewSection('no_offer', _this.offerViews);
      } else {
        // Show `Mogo No Offer` view only to Mogo Members with active loan.
        if (_this._lenderId > 1) {
          // Partner Lender does not get offers
          _this._setupViewSection('no_offer', _this.offerViews);
        } else {
          // Mogo No Offer views are different depending on lender ID.
          _this._setupViewSection('mogo_no_offer', _this.offerViews);
        }
      }
    }
  };

  this._setupViewSection = function (loanStatus, stateObj) {
    var viewPath = void 0;
    var viewId = void 0;
    var view = stateObj[loanStatus];

    if (view) {
      viewPath = view.viewPath;

      if (view.viewId) viewId = view.viewId;
    }

    // Inject View via ajax
    this._viewLoad(viewPath, viewId);
  };

  this._viewLoad = function (viewPath, viewId) {
    if (viewPath) {
      $.ajax({
        url: viewPath,
        type: 'GET',
        headers: {
          'Content-Type': 'text/html'
        },
        dataType: 'html',
        success: this._onViewLoadSuccess.bind(this, viewId)
      });
    } else {
      console.error('LoanOverview: No view path or status');
    }
  };

  this._onViewLoadSuccess = function (viewId, data) {
    // Insert into document
    this._$node.append(data);

    mogo.ready(function (vId) {
      if (!vId) {
        this.analytics.forcePushEvent('virtual-page-view');
        this.analytics.forcePushEvent('mogo-money-status', null, this);
      }

      var element = $('#' + vId);

      if (element.length > 0) {
        // IMPORTANT: must have .js--create-section to create mogo-component first since
        // we are dynamically injecting html in to the page.
        // use Parse to first to create mogo-components
        try {
          element.find('.js--create-section').mogo().parse();
        } catch (err) {
          console.warn(err);
        }

        // Create the page component
        element.mogo().create(vId, {
          presenter: this.presenter,
          analytics: this.analytics
        }, 'page');

        // Invoke Data-History
        // 1. Initialize analytics
        $('#Portal').mogo().scanNodeForClickAnalytics(element);
        // 2. Initialize history
        this.history.initializeHistoryOnDocument(element);

        this.presenter.scanDOM(element[0]);
      }

      // Required when route has defer_page_load_completed: true
      this._portalPresenter.setPageLoadComplete();
    }.bind(this, viewId));
  };

  this.destroy = function () {
    _this._super();
  };
}